import { Card, CardBody } from 'reactstrap';
import './index.css';
import { Col } from 'react-bootstrap';

interface FeedbackCardProps {
    title: string;
    rating: number;
    review: string;
    displayName: string;
}

const FeedbackCard: React.FC<FeedbackCardProps> = ({ displayName, title, rating, review }) => {
    return (
        <Card className="mb-4 p-2 m-3 customer-feedback-card">
            <CardBody>
                <div className='d-flex justify-content-between align-items-left'>
                    <Col lg={12} className='d-flex justify-content-left align-items-center'>
                        <h6 className='fw-bold'>{title}</h6>
                    </Col>
                </div>
                <div className="mb-2">
                    <div className="mb-2">
                        {[...Array(Math.floor(rating))].map((_, i) => (
                            <span key={i} className="text-warning">★</span>
                        ))}
                        {rating % 1 !== 0 && <span className="text-warning">☆</span>}
                    </div>
                </div>
                <i className='review-context'>"{review}"</i>
                <div className='d-flex flex-column justify-content-center'>
                    <h6 className='fw-bold'>-{displayName}</h6>
                </div>
            </CardBody>
        </Card>
    );
};

export default FeedbackCard;